import UncontrolledPopover from 'components/SafeUncontrolledPopover';
import React, { FC, PropsWithChildren } from 'react';

import { FormattedMessage } from 'react-intl';
import { PreviewMode } from 'types';
import { isExtendedCalibrationEnabled, useFeatures } from 'utils/util/features';

interface Props {
  allow_calibration?: boolean;
  previewMode?: PreviewMode;
}

const AllowCalibrationDescriptor: FC<PropsWithChildren<Props>> = ({
  children,
  previewMode,
  ...props
}) => {
  const ref = React.createRef<HTMLSpanElement>();
  const { features } = useFeatures();
  const extendedCalibrationEnabled = isExtendedCalibrationEnabled(features);

  return extendedCalibrationEnabled &&
    // Only show in campaign editor preview mode, do not show while editing nor during the performance
    previewMode === 'CAMPAIGN_EDITOR' &&
    props.allow_calibration ? (
    <div className="d-lg-flex flex-row">
      {children}
      <span ref={ref} className="fw-normal ms-0 ms-md-3 text-nowrap">
        <i className="fe fe-edit-3 text-primary small align-middle me-2" />
        <span className="text-primary small">
          <FormattedMessage
            id="app.views.widgets.inputs.allow_calibration_descriptor.allow_calibration"
            defaultMessage="Allow calibration"
          />
        </span>
      </span>
      <UncontrolledPopover placement="top" trigger="hover" target={ref}>
        <FormattedMessage
          id="app.views.widgets.inputs.allow_calibration_descriptor.calibration_tooltip"
          defaultMessage="The response can be modified by HR/People admins during the calibration process."
        />
      </UncontrolledPopover>
    </div>
  ) : (
    <>{children}</>
  );
};

export default AllowCalibrationDescriptor;
